import React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ChecklistCheckboxWidget(props) {
  var schema = props.schema,
    value = props.value,
    onChange = props.onChange,
    _props$options = props.options,
    image = _props$options.image,
    title = _props$options.title;
  return /*#__PURE__*/_jsx("div", {
    className: "panel panel-default",
    children: /*#__PURE__*/_jsxs("div", {
      className: "panel-body checklist-checkbox-widget ".concat(value ? "checklist-checkbox-selected" : ""),
      children: [/*#__PURE__*/_jsx("span", {
        className: "checklist-checkbox-widget-select",
        onClick: function onClick() {
          onChange(!value);
        },
        children: /*#__PURE__*/_jsx("i", {
          className: "fa fa-check"
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("img", {
          src: image
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("strong", {
            children: title
          }), schema.description && /*#__PURE__*/_jsxs(React.Fragment, {
            children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
              className: "text-muted",
              children: schema.description
            })]
          })]
        })]
      })]
    })
  });
}
export default ChecklistCheckboxWidget;
//# sourceMappingURL=ChecklistCheckboxWidget.js.map